import axios from "axios";
import { authBasicHeader, noTenant } from "./AuthHeader";
import { env } from "../config/env";

const apiUrl = env.API_URL;

class SignupTenantService {
  headers = authBasicHeader("signup_tenant", "signup_tenant_pass");

  saveTenant(payload) {
    return axios.post(apiUrl + "/tenant/signup", payload, {
      headers: {
        ...this.headers,
        ...noTenant()
      }
    });
  }

  getInstallments(query) {
    return axios.get(apiUrl + "/tenant/installments", {
      headers: {
        ...noTenant()
      },
      params: {
        ...query
      }
    })
  }
}

export default new SignupTenantService();
